export default "__VITE_ASSET__lFmZawD$__"